import { render, staticRenderFns } from "./PurchasedDigiBoardTimeSlotsList.vue?vue&type=template&id=e74e87d0&scoped=true&"
import script from "./PurchasedDigiBoardTimeSlotsList.vue?vue&type=script&lang=js&"
export * from "./PurchasedDigiBoardTimeSlotsList.vue?vue&type=script&lang=js&"
import style0 from "./PurchasedDigiBoardTimeSlotsList.vue?vue&type=style&index=0&id=e74e87d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74e87d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VDataTable,VIcon,VRow,VTextField})
